import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async (_, params) => {
  Vue.prototype.$loading(true)

  try {
    const { data } = await axios.get('whitelabel-usage', { params })

    return data
  } catch (error) {
    return error
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const createAccess = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const { data } = await axios.post('whitelabel-access', body)

    return data
  } catch (error) {
    return error
  } finally {
    Vue.prototype.$loading(false)
  }
}
